import { statusTypes } from "constants/common"
import {
  GET_GUESTS_FAIL,
  GET_GUESTS_SUCCESS,
  GET_GUEST_DETAIL_FAIL,
  GET_GUEST_DETAIL_SUCCESS,
  ADD_GUEST_SUCCESS,
  ADD_GUEST_FAIL,
  UPDATE_GUEST_SUCCESS,
  UPDATE_GUEST_FAIL,
  CLEAR_MESSAGE,
  DELETE_GUEST_SUCCESS,
  DELETE_GUEST_FAIL,
  UPDATE_GUEST_ACCESS_SUCCESS,
  UPDATE_GUEST_ACCESS_FAIL,
  GET_EXPORT_GUEST_SUCCESS,
  GET_EXPORTED_GUEST_FAIL,
  RESET_EXPORT_DATA,
  GUEST_COMPLIMENTARY_ACCESS_REQUEST,
  GUEST_COMPLIMENTARY_ACCESS_REQUEST_SUCCESS,
  GUEST_COMPLIMENTARY_ACCESS_REQUEST_FAIL,
  GUEST_COMPLIMENTARY_ACCESS_GRANT_SUCCESS,
  GUEST_COMPLIMENTARY_ACCESS_GRANT_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  guestList: [],
  guestDetail: {},
  error: {},
  message: "",
  pagination: {},
  search: "",
  file: "",
}

const guests = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GUESTS_SUCCESS:
      return {
        ...state,
        guestList: action?.payload?.data || [],
        pagination: action?.payload?.pagination || {},
      }

    case GET_GUESTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_GUEST_SUCCESS:
      return {
        ...state,
        guestList: [...state.guestList, action?.payload?.data || {}],
        message: action?.payload?.message || "",
      }

    case ADD_GUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_GUEST_DETAIL_SUCCESS:
      return {
        ...state,
        guestDetail: action.payload,
      }

    case UPDATE_GUEST_SUCCESS:
      return {
        ...state,
        message: "Successfully guest updated!",
        guestList: (state?.guestList || []).map(guest => {
          return guest._id.toString() === action.payload?.data._id.toString()
            ? { guest, ...action.payload?.data }
            : guest
        }),
      }

    case UPDATE_GUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_GUEST_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_GUEST_SUCCESS:
      return {
        ...state,
        message: "Successfully guest deleted!",
        guestList: (state?.guestList || []).map(guest => {
          return guest._id.toString() === action.payload?._id.toString()
            ? { ...guest, status: statusTypes.Removed }
            : guest
        }),
      }

    case DELETE_GUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    case UPDATE_GUEST_ACCESS_SUCCESS:
      return {
        ...state,
        message: "Successfully guest updated!",
        guestList: [],
      }

    case UPDATE_GUEST_ACCESS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_EXPORT_GUEST_SUCCESS:
      return {
        ...state,
        message: action.payload?.message,
        file: action.payload?.file,
        error: {},
      }

    case GET_EXPORTED_GUEST_FAIL:
      return {
        ...state,
        file: "",
        error: action.payload?.message || "Error occurred in export file.",
      }

    case RESET_EXPORT_DATA:
      return {
        ...state,
        error: {},
        message: "",
        file: "",
      }

    case GUEST_COMPLIMENTARY_ACCESS_REQUEST_SUCCESS: return {
      ...state,
      error:{},
      message: "Guest Complimentary Acess Request Sent to Complimentary Authority"
    }

    case GUEST_COMPLIMENTARY_ACCESS_REQUEST_FAIL: return {
      ...state,
      error: "Failed to Request Complimentary Access",
    }

    case GUEST_COMPLIMENTARY_ACCESS_GRANT_SUCCESS: return {
      ...state,
      error:{},
      message: action.payload.status === "Approved" ? "Guest Granted Access Without Complimentary" : "Guest Granted Access With Complimentary",
    }

    case GUEST_COMPLIMENTARY_ACCESS_GRANT_FAIL: return {
      ...state,
      error: "Failed to Grant Complimentary Access",
    }

    default:
      return state
  }
}

export default guests
